import { useCallback, useEffect, useRef, useState } from 'react';
import useDebouncedCallback from '../useDebounceCallback/useDebouncedCallback';
import type { UseDebounce, CompareValue } from './types';

const useDebounce: UseDebounce = (value, delay, options) => {
  const compareValueDefault: CompareValue<typeof value> = useCallback(
    (left, right) => left === right,
    []
  );

  const compareValue = options?.compareValue ?? compareValueDefault;

  const [state, setState] = useState(value);

  const [callback, cancel, callPending] = useDebouncedCallback(
    useCallback((currentValue: typeof value) => setState(currentValue), []),
    delay,
    options
  );

  const previousValue = useRef(value);

  useEffect(() => {
    if (!compareValue(previousValue.current, value)) {
      callback(value);
      previousValue.current = value;
    }
  }, [value, callback, compareValue]);

  return [state, cancel, callPending];
};

export default useDebounce;
